import { render, staticRenderFns } from "./device-info.vue?vue&type=template&id=15486119&scoped=true"
import script from "./device-info.vue?vue&type=script&lang=js"
export * from "./device-info.vue?vue&type=script&lang=js"
import style0 from "./device-info.vue?vue&type=style&index=0&id=15486119&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15486119",
  null
  
)

export default component.exports